import React, { useEffect } from "react";
import AOS from "aos";
import { Link } from "react-router-dom";
import "aos/dist/aos.css";
import "./looking-loan.css";

// Images
import LoanImage from "../assets/images/Looking_Loan.jpg";
import LoanGif from "../assets/images/looking-loan.gif";

const LoanSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="loan-section">
      <div className="container py-5">
        <div className="row align-items-center">
          {/* Left Image */}
          <div className="col-md-6" data-aos="fade-right">
            <img
              src={LoanImage}
              alt="Looking for a Loan"
              className="img-fluid loan-section__image"
              loading="lazy"
            />
          </div>

          {/* Right Text */}
          <div className="col-md-6 mt-4 mt-md-0 position-relative" data-aos="fade-left">
            <h2 className="loan-section__title">
              Looking for a <span className="highlight">Loan?</span>
            </h2>

            <p className="loan-section__desc">
              Turn your ambitions into reality with our exclusive loan solutions. Whether it’s purchasing a home, launching a business, or fulfilling personal aspirations, experience seamless support designed for your success.
            </p>

            <ul className="loan-section__list">
              <li>✅ Fast Approval</li>
              <li>✅ Flexible Payments</li>
              <li>✅ Competitive Rates</li>
              <li>✅ Minimal Documents</li>

              {/* GIF */}
              <img src={LoanGif} alt="Loan Animation" className="loan-gif" />
            </ul>

            <Link to="/apply-now" className="btn loan-section__btn">
              Apply Now
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoanSection;
